import * as Yup from "yup";

const usuarioUpdateValidator = Yup.object().shape({
  nome: Yup.string().required("Nome"),
});

export default usuarioUpdateValidator;
